export default function bbffFilename(name: string) {
  return `C:/Users/BBFF/${name}`;
}
